import React, { useContext } from 'react';
import styled from 'styled-components';
import { AgroHeaderContext } from '../../contexts/AgroHeaderContext';
import { Text } from '../../atoms/Text';
import { IarrowRight2, Iquit, Istatistics, IavatarUser, Icalendar, IchatOnline, Idisplay, Idocument, Ienvelope, IlightMode, ImicLow, Iyoutube, Isubtract, Ilist2, Istore } from '../../atoms/AgroIcon/icons';
var ItemList = function ItemList(_ref) {
  var item = _ref.item,
    index = _ref.index,
    notifications = _ref.notifications,
    title = _ref.title,
    level = _ref.level,
    handleNext = _ref.handleNext,
    hasNotifications = _ref.hasNotifications,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles;
  var _useContext = useContext(AgroHeaderContext),
    user = _useContext.user,
    logoutFunction = _useContext.logoutFunction,
    loginUrlRedirect = _useContext.loginUrlRedirect;
  var linkHref = item.Name === 'Ingresar' || item.Name === 'Entrar' ? "".concat(item.URL, "&redirect=").concat(loginUrlRedirect) : item.URL;
  return /*#__PURE__*/React.createElement(StyledItem, {
    className: !(item !== null && item !== void 0 && item.Icon) ? 'no-icon' : '',
    isLogged: user,
    isTitle: level === 1 && !item.URL,
    level: level,
    title: title,
    onClick: function onClick(event) {
      return handleNext(event, item);
    },
    style: styles
  }, /*#__PURE__*/React.createElement(StyledItemLink, {
    href: linkHref,
    onClick: function onClick() {
      if (item.Name === 'Cerrar sesión' || item.Name === 'Sair') {
        logoutFunction();
      }
    },
    title: title,
    idx: index
  }, /*#__PURE__*/React.createElement(StyledItemName, null, item.Icon ? function () {
    switch (item.Icon) {
      case 'Istatistics':
        return /*#__PURE__*/React.createElement(StyledIcon, null, /*#__PURE__*/React.createElement(Istatistics, {
          width: "16px",
          height: "16px",
          fill: "green500"
        }));
      case 'IavatarUser':
        return /*#__PURE__*/React.createElement(StyledIcon, null, /*#__PURE__*/React.createElement(IavatarUser, {
          width: "16px",
          height: "16px",
          fill: "green500"
        }));
      case 'Icalendar':
        return /*#__PURE__*/React.createElement(StyledIcon, null, /*#__PURE__*/React.createElement(Icalendar, {
          width: "16px",
          height: "16px",
          fill: "green500"
        }));
      case 'IchatOnline':
        return /*#__PURE__*/React.createElement(StyledIcon, null, /*#__PURE__*/React.createElement(IchatOnline, {
          width: "16px",
          height: "16px",
          fill: "green500"
        }));
      case 'Idisplay':
        return /*#__PURE__*/React.createElement(StyledIcon, null, /*#__PURE__*/React.createElement(Idisplay, {
          width: "16px",
          height: "16px",
          fill: "green500"
        }));
      case 'Idocument':
        return /*#__PURE__*/React.createElement(StyledIcon, null, /*#__PURE__*/React.createElement(Idocument, {
          width: "16px",
          height: "16px",
          fill: "green500"
        }));
      case 'Ienvelope':
        return /*#__PURE__*/React.createElement(StyledIcon, null, /*#__PURE__*/React.createElement(Ienvelope, {
          width: "16px",
          height: "16px",
          fill: "green500"
        }));
      case 'IlightMode':
        return /*#__PURE__*/React.createElement(StyledIcon, null, /*#__PURE__*/React.createElement(IlightMode, {
          width: "16px",
          height: "16px",
          fill: "green500"
        }));
      case 'ImicLow':
        return /*#__PURE__*/React.createElement(StyledIcon, null, /*#__PURE__*/React.createElement(ImicLow, {
          width: "16px",
          height: "16px",
          fill: "green500"
        }));
      case 'Iyoutube':
        return /*#__PURE__*/React.createElement(StyledIcon, null, /*#__PURE__*/React.createElement(Iyoutube, {
          width: "16px",
          height: "16px",
          fill: "green500"
        }));
      case 'Isubtract':
        return /*#__PURE__*/React.createElement(StyledIcon, null, /*#__PURE__*/React.createElement(Isubtract, {
          width: "16px",
          height: "16px",
          fill: "green500"
        }));
      case 'Iquit':
        return /*#__PURE__*/React.createElement(StyledIcon, null, /*#__PURE__*/React.createElement(Iquit, {
          width: "16px",
          height: "16px",
          fill: "green500"
        }));
      case 'Ilist2':
        return /*#__PURE__*/React.createElement(StyledIcon, null, /*#__PURE__*/React.createElement(Ilist2, {
          width: "16px",
          height: "16px",
          fill: "green500"
        }));
      case 'Istore':
        return /*#__PURE__*/React.createElement(StyledIcon, null, /*#__PURE__*/React.createElement(Istore, {
          width: "16px",
          height: "16px",
          fill: "green500"
        }));
      default:
        return /*#__PURE__*/React.createElement("img", {
          src: item.Icon,
          alt: item.Name
        });
    }
  }() : index === 101 ? /*#__PURE__*/React.createElement(StyledCloseSessionIcon, null) : null, /*#__PURE__*/React.createElement(StyledTextName, {
    type: level === 1 && !item.URL ? 'number-lg' : 'label-md'
  }, item.Name), notifications && hasNotifications(item)), /*#__PURE__*/React.createElement(StyledItemArrow, null, item.Children && item.Children.length > 0 ? /*#__PURE__*/React.createElement(IarrowRight2, {
    width: "24px",
    height: "24px",
    fill: "gray900"
  }) : '')));
};
var StyledCloseSessionIcon = styled(Iquit).withConfig({
  displayName: "ItemList__StyledCloseSessionIcon",
  componentId: "sc-4n7vay-0"
})(["width:16px;height:16px;margin-right:16px;fill:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.gray900;
});
var StyledItem = styled.li.withConfig({
  displayName: "ItemList__StyledItem",
  componentId: "sc-4n7vay-1"
})(["padding:14px 16px 14px 16px;align-items:center;gap:16px;align-self:stretch;"]);
var StyledItemLink = styled.a.withConfig({
  displayName: "ItemList__StyledItemLink",
  componentId: "sc-4n7vay-2"
})(["display:flex;justify-content:space-between;align-items:center;color:", ";height:100%;text-decoration:none;border-style:hidden;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.gray800;
});
var StyledTextName = styled(Text).withConfig({
  displayName: "ItemList__StyledTextName",
  componentId: "sc-4n7vay-3"
})(["color:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.gray900;
});
var StyledSecondIcon = styled.span.withConfig({
  displayName: "ItemList__StyledSecondIcon",
  componentId: "sc-4n7vay-4"
})([""]);
var StyledItemName = styled.div.withConfig({
  displayName: "ItemList__StyledItemName",
  componentId: "sc-4n7vay-5"
})(["display:flex;align-items:center;> img{height:16px;margin:0 16px 0 0;width:16px;}"]);
var StyledItemArrow = styled.div.withConfig({
  displayName: "ItemList__StyledItemArrow",
  componentId: "sc-4n7vay-6"
})([""]);
var StyledIcon = styled.div.withConfig({
  displayName: "ItemList__StyledIcon",
  componentId: "sc-4n7vay-7"
})(["margin-right:16px;display:flex;align-items:center;"]);
export default ItemList;